// extracted by mini-css-extract-plugin
export default {"activeClaim":"Claims_activeClaim__wWKmo","claimStatusContainer":"Claims_claimStatusContainer__K+JBC"};